export default {"src":"/_next/static/media/Meeting.96dbbab4.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};